import { render, staticRenderFns } from "./DirectionsPanel.vue?vue&type=template&id=b2b136e6"
import script from "./DirectionsPanel.vue?vue&type=script&lang=js"
export * from "./DirectionsPanel.vue?vue&type=script&lang=js"
import style0 from "./DirectionsPanel.vue?vue&type=style&index=0&id=b2b136e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports